/**
 * 结算管理api
 */
export default {
  getCompanySettlementList: '/companySettlement/listPage',  // 平台明细-服务订单(项目订单列表)
  getSettlementOrderList: '/settlementOrder/listPage',  // 平台/门店 商品订单列表
  getSettlementOrderDetail: '/settlementOrder/detail',  // 平台/门店 商品订单列表-详情
  getStoreSettlementList: '/storeSettlement/listPage',  // 门店明细-服务列表 项目订单列表
  getProjectConsumeList: '/projectConsume/list',  // 提成明细




  selectExtractApplyList: '/extractApply/pageList', // 查询提现List
  selectExtractApplyListDetail: '/extractApply/pageListDetails',   // 查询提现详情
  auditingExtractApply: '/extractApply/auditing',  // 审核失败
};
